import React from 'react'
import Stack from '@mui/material/Stack'
import Button from '../Button'

export interface ActionButtonsProps {
  isDeclinedOrCancelled?: boolean
  requestIsLocked?: boolean
  declineDisabled: boolean
  submitDisabled: boolean | undefined
  approveLoading: boolean
  onDecline: () => void
  onApprove: () => void
  hasChanges: boolean
  isButtonDisabled?: boolean
  showRejectButton: boolean
  onReject?: () => void
  onApproveWithChanges?: () => void
  declineLabel: string
}
const ActionButtons: React.FC<ActionButtonsProps>  = function ({
                         isDeclinedOrCancelled,
                         requestIsLocked,
                         declineDisabled,
                         submitDisabled,
                         approveLoading,
                         onDecline,
                         onApprove,
                         hasChanges,
                         showRejectButton, 
                         onReject,
  onApproveWithChanges,
  declineLabel
                       }) {
  return (
    <Stack
      direction={{xs: 'column-reverse', md: 'row'}}
      justifyContent="space-between"
      gap={{xs: 0, md: 4}}
    >
      {showRejectButton && (
        <Button
          label="Reject"
          variant="outlined"
          color="secondary"
          disabled={isDeclinedOrCancelled || requestIsLocked || declineDisabled || approveLoading}
          onClick={onReject}
        />
      )}
      <Button
        label={declineLabel}
        variant="outlined"
        color="secondary"
        disabled={isDeclinedOrCancelled || requestIsLocked || declineDisabled || approveLoading}
        onClick={onDecline}
        data-testid="decline-button"
      />
      <Button
        label={hasChanges ? 'Approve With Changes' : 'Approve'}
        variant="outlined"
        color="primary"
        disabled={isDeclinedOrCancelled || requestIsLocked || submitDisabled}
        onClick={hasChanges ? onApproveWithChanges : onApprove}
        loading={approveLoading}
        dataTestId='approve-button'
      />
    </Stack>
  )
}


export default ActionButtons